module.exports = __webpack_public_path__ + "static/img/c2.be75c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c2.png
// module id = mt4l
// module chunks = 1